import { SxProps } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

/* c8 ignore start */
export const sliderStyle = (theme: ThemeV2, isSlider: boolean): SxProps => ({
  // The slider's state colors follow the survey palette in every question family.
  height: 2,
  color: theme.tokens.color.action.primary,
  padding: `${theme.tokens.spacing["4"]}px 0`,
  width: "100%",

  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    marginLeft: "5px",
    display: isSlider ? "none" : "block",
  },

  "& .MuiSlider-track": {
    border: "none",
    opacity: isSlider ? 0.5 : null,
    color: isSlider ? theme.tokens.color.border.strong : "",
  },
  "& .MuiSlider-markActive": isSlider
    ? {
        color: theme.tokens.color.surface.card,
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: `${theme.tokens.shape.radius.pill}px`,
        borderColor: theme.tokens.color.action.primary,
      }
    : {},

  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: theme.tokens.color.border.strong,
  },
  "& .MuiSlider-mark": {
    backgroundColor: theme.tokens.color.surface.card,
    height: "10px",
    width: "10px",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: `${theme.tokens.shape.radius.pill}px`,

    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "currentColor",
    },
  },
});
/* c8 ignore end */
